import React from 'react';
import $ from 'jquery';

class Banner extends React.Component {
        render() {
          return (
          	<section className="team about-team">
			  <div className="teaminner2">
			    <div className="teaminner">
			      <div className="teaminnermain">
			        <div className="container">
			          <div className="row">
			            <div className="col-md-5 breeserif titletext">
			              <h1 className="breeserif">Go the Distance<br />&nbsp;</h1>
			            </div>
			            <div className="col-md-push-2 col-md-5 visible-lg"><img src="images/MVP-Hero-Circle-2.png" alt="" className="img-responsive center-block" /></div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</section>
          );
        }
}

class MainContent extends React.Component {
		componentDidMount() {
			 $('.contact_button').click(function() { 
			  $(".errors").html(""); 
       			$.post("http://saxe.com/mvp/react/public/includes/validation.php", $('#ContactForm').serialize(), function(data) {
               if(data.status === false)  { 
               	 var errors=data.content;
                   $.each(errors, function(key, value) {             
                        if (value !== "") {   
                              $("#err_" + key).html(value);  
                        }else{
                          $("#err_" + key).html("");
                        }
                    });  
                   return false;
                }  else {
                	 $(".errors").html(""); 
                	 $('#ContactForm')[0].reset();
                     $(".message").html("Thank you for your submission.");
                }  

           }, 'json');
                
              });
		}
        render() {
          return (
          <div>
          	<div className="container">
			  <div className="infobox-video">
			    <div className="row pad-top-40">
			      <div className="col-sm-12">
			        <h1><span className="video-bg">We Look <br className="break" />Forward to <br className="break" />Hearing <br className="break" />From You</span></h1>

			      </div>
			    </div>
			  </div>
			</div>
			<div className="container">
			  <div className="infobox">
			    <div className="row">
					<div className="col-sm-1"></div>
			      <div className="col-sm-10">	  
					  <p className="flamaitalic font24 text-center">Please contact us if you would like to learn more about our business and services.</p>
			      </div>
			<div className="col-sm-1"></div>
			      <div className="col-sm-12">	
			      <h3 style={{"textAlign":"center"}}>
			<span className="breeserif">Most Valuable Personnel</span><br />
			1751 Lake Cook Road<br />
			Suite 600<br />
			Deerfield, IL 60015<br />
			1-855-MVP-9090
			  </h3>
			  </div>
			      </div>
			    </div>
			  </div>
			<div className="container-fluid">
				<form className="cbp-mc-form cmxform" id="ContactForm" name="contact-form" method="post" action="http://saxe.com/mvp/react/public/includes/contactus.php">
					<div className="cbp-mc-column"></div>
					<div className="cbp-mc-column ctn_form">
						<p className="message text-success text-center breeserif"></p>
						<label htmlFor="name"> Name <span>*</span></label>
						<input className="" id="name" name="name" placeholder="" type="text" required="" />
			            <span className="text-danger errors" id="err_name"></span>
						<label htmlFor="email">Email <span>*</span></label>
						<input className="" id="email" name="email" placeholder="" required="" type="text" />
			            <span className="text-danger errors" id="err_email"></span>
						<label htmlFor="address">Phone Number</label>
						<input className="" id="phone" name="phone" placeholder="" type="text" />
			            <span className="text-danger errors" id="err_phone"></span>
						<label htmlFor="question">Question <span>*</span></label>
						<input className="err" id="question" style={{"height":"100px"}} name="question" required="" /> 
			            <span className="text-danger errors" id="err_question"></span> 
						<div><label><span>* Required Fields</span></label></div>
					</div>
					<div className="cbp-mc-column"></div>
					<div className="cbp-mc-submit-wrap"><input className="cbp-mc-submit contact_button" id="c_sub" value="Submit" type="button" /></div>
					<input name="page_type" value="contact" type="hidden" />
				</form>
			</div>	
		</div>	
          );
        }
}




function Contact() {
  return (
  <div>
      <Banner />
      <MainContent />
  </div>    
  );
}

export default Contact


// WEBPACK FOOTER //
// ./src/contact.js